'use client';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Col, Container, Row } from 'react-bootstrap';
import LinkOnly from '@/src/components/common/ui/buttons/LinkOnly.jsx';
import { useShowSetting } from '@/src/components//context/ShowSettingProvider.jsx';
import ReactHtmlParser from 'react-html-parser';
import reactHtmlParser from 'react-html-parser';
import Link from 'next/link';
import useDeviceTypeMobile from '@/src/hooks/useDeviceTypeMobile.jsx';
import { usePathname } from 'next/navigation';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Social from '@/src/components/common/ui/social/Social.jsx';
import gsap from 'gsap';
import DrawSVGPlugin from 'gsap/dist/DrawSVGPlugin';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
import FooterSocial from '@/src/components/common/ui/social/FooterSocial.jsx';
if (typeof window !== 'undefined') {
	gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, ScrollToPlugin);
}


const Footer = ({bg}) => {
	const footerDate = useShowSetting();
	const footerMenu = footerDate?.getMenu?.footer_menu;
	const footerMenuBottom = footerDate?.getMenu?.footer_menu_bottom;
	const settingsData = footerDate?.getSettings;
	const isMobile = useDeviceTypeMobile()
	const d = new Date();
	let year = d.getFullYear();
	const location = usePathname();
	const isFieldMountCategory = location?.startsWith('/industries/');
	const officePhones = settingsData?.office_phone?.split(',') || [];
	const pathname = usePathname();
	const { contact_email, google_map_link, office_location, office_phone, facebook, linkedin, twitter, youtube } = footerDate || {};

	const handleScrollTo = (e, hash) => {
		if (!hash) return;
		e.preventDefault();
		const id = hash.startsWith('#') ? hash.slice(1) : hash;
		const targetElement = document.getElementById(id);
		if (!targetElement) return;

		const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

		const offsets = {
			'#services': 130,  // positive offset, scroll above element
			'#products': 150,
		};

		const offset = offsets[hash] ?? 0;

		const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
		let scrollPos = targetPosition - offset;
		if (scrollPos > maxScroll) scrollPos = maxScroll;
		if (scrollPos < 0) scrollPos = 0;

		gsap.to(window, {
			scrollTo: scrollPos,
			duration: 1,
			ease: "power2.out"
		});
	};




	return (
		<StyledComponent bg={isFieldMountCategory ? '#EFEFEF' :bg} className="footer" >
			<div className="footer-wrapper">
				<Container className={'footer_first'}>
					<Row className={''}>
						<Col className={'footer_logo align-items-center justify-content-center d-flex'} md={{ span: 8, offset: 2 }}>
							<div className="footer-fav-logo">
								<img  loading="lazy"  src={process.env.NEXT_PUBLIC_API_URL + '/admin/' + settingsData?.logo_footer_fav} alt="" />
							</div>
						</Col>
						<Col className={'footer_menu'} md={{ span: 8, offset: 2 }}>
							{
								footerMenu && footerMenu?.length > 0 &&
								<ul className={'d-flex'}>
									{

										footerMenu && footerMenu?.length > 0 &&
										footerMenu?.map((e, index) => {
											return (
												<li key={index} 		>
													{
														isMobile ?
															<LinkOnly
																text={ReactHtmlParser(e?.item_title)}
																hoverbackground="#ED2024"
																src={pathname === '/' ? e?.item_url : '/' + e?.item_url}
																color="#fff"
															/>
															:

															<LinkOnly
																onClickHandle={(item) => {
																	if (pathname === '/') {
																		const hash = e.item_url.split('#')[1];


																		if (hash) {
																			item.preventDefault();

																			const el = document.getElementById(hash);
																			if (el) {
																				const newUrl = `${window.location.pathname}#${hash}`;
																				window.history.replaceState(null, '', newUrl);
																				handleScrollTo(item, `#${hash}`);
																				ScrollTrigger.refresh();
																			}
																		} else {
																			// No hash, so just close menu (default navigation)
																		}
																	}
																}}
																text={ReactHtmlParser(e?.item_title)}
																hoverbackground="#ED2024"
																src={pathname === '/' ? e?.item_url : '/' + e?.item_url}
																color="#fff"
															/>
													}


												</li>
											);
										})

									}
								</ul>
							}

							{
								isMobile &&
								<FooterSocial facebook={settingsData?.facebook} instra={settingsData?.instagram} twitter={settingsData?.twitter} youtube={settingsData?.youtube} />

							}

						</Col>
						<Col className={'footer_address'} md={{ span: 8, offset: 2 }}>

							<div className="address-wrapper">
								{
									isMobile &&
									<div className="icon">
										<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M10.0004 7.00048C10.0004 7.79613 9.68436 8.55919 9.12176 9.1218C8.55915 9.68441 7.79608 10.0005 7.00043 10.0005C6.20478 10.0005 5.44172 9.68441 4.87911 9.1218C4.3165 8.55919 4.00043 7.79613 4.00043 7.00048C4.00043 6.20483 4.3165 5.44177 4.87911 4.87916C5.44172 4.31655 6.20478 4.00048 7.00043 4.00048C7.79608 4.00048 8.55915 4.31655 9.12176 4.87916C9.68436 5.44177 10.0004 6.20483 10.0004 7.00048ZM9.00043 7.00048C9.00043 6.47005 8.78972 5.96134 8.41465 5.58627C8.03958 5.21119 7.53087 5.00048 7.00043 5.00048C6.47 5.00048 5.96129 5.21119 5.58622 5.58627C5.21115 5.96134 5.00043 6.47005 5.00043 7.00048C5.00043 7.53091 5.21115 8.03962 5.58622 8.41469C5.96129 8.78977 6.47 9.00048 7.00043 9.00048C7.53087 9.00048 8.03958 8.78977 8.41465 8.41469C8.78972 8.03962 9.00043 7.53091 9.00043 7.00048ZM11.9504 11.9555C13.2633 10.6419 14.0009 8.86069 14.0009 7.00348C14.0009 5.14627 13.2633 3.36507 11.9504 2.05148C11.3004 1.4014 10.5287 0.885716 9.67938 0.533888C8.83006 0.182061 7.91975 0.000976563 7.00043 0.000976562C6.08112 0.000976563 5.17081 0.182061 4.32149 0.533888C3.47216 0.885716 2.70045 1.4014 2.05043 2.05148C0.737527 3.36507 0 5.14627 0 7.00348C0 8.86069 0.737527 10.6419 2.05043 11.9555L3.57143 13.4545L5.61443 15.4395L5.74743 15.5575C6.52243 16.1855 7.65743 16.1455 8.38743 15.4395L10.8224 13.0695L11.9504 11.9555ZM2.75543 2.75648C3.31267 2.19862 3.9744 1.75607 4.70279 1.45412C5.43118 1.15218 6.21194 0.996762 7.00043 0.996762C7.78893 0.996762 8.56969 1.15218 9.29808 1.45412C10.0265 1.75607 10.6882 2.19862 11.2454 2.75648C12.3397 3.85218 12.9688 5.32796 13.0016 6.87615C13.0344 8.42434 12.4683 9.92544 11.4214 11.0665L11.2454 11.2505L9.92443 12.5545L7.69443 14.7235L7.60043 14.8035C7.42723 14.9332 7.21664 15.0032 7.00027 15.003C6.7839 15.0028 6.57342 14.9324 6.40043 14.8025L6.30743 14.7225L3.32743 11.8175L2.75543 11.2505L2.57943 11.0675C1.53254 9.92644 0.966485 8.42534 0.999275 6.87715C1.03206 5.32896 1.66117 3.85218 2.75543 2.75648Z"
												fill="white" />
										</svg>
									</div>
								}
								<LinkOnly className={'address'} color={'#fff'} src={settingsData?.google_map_link} target={'_blank'} text={ReactHtmlParser(settingsData?.office_location)} />
							</div>

							<div className="address_information d-flex align-items-center ">

								<div className="phone-number-list single-address-item d-flex">
									{
										isMobile &&
										<div className="icon">
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M14.93 16C13.2447 16 11.5167 15.578 9.746 14.734C7.97533 13.89 6.33033 12.705 4.811 11.179C3.29167 9.653 2.11 8.008 1.266 6.244C0.422 4.48 0 2.75533 0 1.07C0 0.764667 0.1 0.510333 0.3 0.307C0.5 0.103667 0.75 0.00133333 1.05 0H3.523C3.795 0 4.03233 0.0856666 4.235 0.257C4.43767 0.428333 4.57467 0.648 4.646 0.916L5.142 3.3C5.18867 3.58 5.18033 3.82433 5.117 4.033C5.05367 4.24167 4.94267 4.41267 4.784 4.546L2.59 6.592C3.00067 7.33667 3.45433 8.02867 3.951 8.668C4.44767 9.30733 4.97767 9.913 5.541 10.485C6.121 11.065 6.74567 11.605 7.415 12.105C8.08433 12.6043 8.819 13.0757 9.619 13.519L11.758 11.342C11.9207 11.1667 12.1037 11.051 12.307 10.995C12.5097 10.9397 12.7343 10.9287 12.981 10.962L15.084 11.392C15.356 11.4587 15.5767 11.5957 15.746 11.803C15.9153 12.0103 16 12.2477 16 12.515V14.95C16 15.25 15.898 15.5 15.694 15.7C15.49 15.9 15.2347 16 14.93 16ZM2.12 5.654L4.04 3.889C4.10333 3.83767 4.14467 3.767 4.164 3.677C4.184 3.587 4.18067 3.50367 4.154 3.427L3.711 1.307C3.685 1.205 3.64 1.12833 3.576 1.077C3.512 1.02567 3.429 1 3.327 1H1.275C1.19833 1 1.13433 1.02567 1.083 1.077C1.03167 1.12833 1.006 1.19233 1.006 1.269C1.02533 1.95233 1.13233 2.66567 1.327 3.409C1.52167 4.15233 1.78533 4.90067 2.12 5.654ZM10.571 13.988C11.247 14.3227 11.967 14.5703 12.731 14.731C13.4963 14.891 14.163 14.9767 14.731 14.988C14.8077 14.988 14.8717 14.9623 14.923 14.911C14.9743 14.8597 15 14.796 15 14.72V12.712C15 12.61 14.9743 12.5267 14.923 12.462C14.8717 12.398 14.795 12.3533 14.693 12.328L12.843 11.949C12.7657 11.923 12.698 11.9197 12.64 11.939C12.5827 11.959 12.522 12.0007 12.458 12.064L10.571 13.988Z"
													fill="white" />
											</svg>
										</div>
									}
									{officePhones.map((phone, index) => (
										<React.Fragment key={index}>
											<LinkOnly
												className="email"
												index={index}
												color="#fff"
												src={`tel:${phone}`}
												text={ReactHtmlParser(phone)}
											/>
											{index !== officePhones.length - 1 && reactHtmlParser(', &nbsp;')}
										</React.Fragment>
									))}
								</div>
								<div className="email-list single-address-item">
									{
										isMobile &&
										<div className="icon">
											<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M17.4354 0.0654297H2.56543C1.90239 0.0654297 1.2665 0.328822 0.797663 0.797663C0.328822 1.2665 0.0654297 1.90239 0.0654297 2.56543V13.4354C0.0654297 14.0985 0.328822 14.7344 0.797663 15.2032C1.2665 15.672 1.90239 15.9354 2.56543 15.9354H17.4354C18.0985 15.9354 18.7344 15.672 19.2032 15.2032C19.672 14.7344 19.9354 14.0985 19.9354 13.4354V2.56543C19.9354 1.90239 19.672 1.2665 19.2032 0.797663C18.7344 0.328822 18.0985 0.0654297 17.4354 0.0654297ZM2.56543 1.06543H17.4354C17.8139 1.06458 18.1785 1.20776 18.4552 1.46591C18.7319 1.72406 18.9 2.07784 18.9254 2.45543C16.4554 3.77543 13.9754 5.08543 11.4954 6.40543C11.1605 6.61664 10.8054 6.79418 10.4354 6.93543C10.1453 6.99287 9.84634 6.9878 9.55836 6.92055C9.27039 6.8533 9.00007 6.72542 8.76543 6.54543C7.34543 5.79543 5.92543 5.03543 4.51543 4.28543C3.37543 3.68543 2.21543 3.07543 1.07543 2.46543C1.09839 2.08606 1.26545 1.7298 1.54243 1.46955C1.81941 1.2093 2.18537 1.06474 2.56543 1.06543ZM18.9354 13.4354C18.9354 13.8333 18.7774 14.2148 18.4961 14.4961C18.2148 14.7774 17.8333 14.9354 17.4354 14.9354H2.56543C2.1676 14.9354 1.78607 14.7774 1.50477 14.4961C1.22346 14.2148 1.06543 13.8333 1.06543 13.4354V3.60043C3.42543 4.84043 5.77543 6.10043 8.13543 7.35043C8.55696 7.60917 9.01091 7.81092 9.48543 7.95043C10.1798 8.06352 10.8915 7.91761 11.4854 7.54043C12.9354 6.78043 14.3754 6.01043 15.8254 5.25043C16.8654 4.69043 17.8954 4.15043 18.9354 3.60043V13.4354Z"
													fill="white" />
											</svg>

										</div>
									}
									<LinkOnly color={'#fff'} src={`mailto:${settingsData?.contact_email}`} text={ReactHtmlParser(settingsData?.contact_email)} />

								</div>

							</div>

						</Col>
					</Row>
				</Container>
				<Container className={'last-container'}>
					<Row className={'last-container_column'}>
						<Col md={6}>
							<p>©{year} {reactHtmlParser(settingsData?.copyright_text)}</p>
						</Col>
						<Col md={6}>
							<Link className={'d-inline-flex gap-2'} href={'https://dcastalia.com'} target={'_blank'}>
								<p>Site by Dcastalia</p>
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="20" height="20" fill="url(#pattern0_512_124558)" />
									<defs>
										<pattern id="pattern0_512_124558" patternContentUnits="objectBoundingBox" width="1" height="1">
											<use xlinkHref="#image0_512_124558" transform="scale(0.002)" />
										</pattern>
										<image id="image0_512_124558" width="500" height="500" preserveAspectRatio="none"
											   xlinkHref="data:image/png;base64,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" />
									</defs>
								</svg>
							</Link>
						</Col>
					</Row>
				</Container>
			</div>
		</StyledComponent>
	);
};

const StyledComponent = styled.section`
    padding: 0;
    background: #5D8D3B;
    position: relative;
    overflow: hidden;
    z-index: 0;

    .dc-btn-link {
        a {
            &:hover {
                color: #152637 !important;
            }
        }
    }

	.footer-fav-logo{
		img{
            height: 70px;
		}
	}
    @media (max-width: 767px) {
        opacity: 1;
    }

    .fixed-bg-wrapper {
        position: relative;

        &.paddingAdd {
            padding-top: 120px;
        }

        img, svg {
            width: 100%;
            height: 100%;
        }

    }

    .top-fixed-footer {
        position: relative;
        left: 0;
        right: 0;
        top: -200px;

        svg {
            width: 100%;
        }
    }

    .footer-wrapper {
        background: #5D8D3B;
        padding: 100px 0 30px;

        .footer_logo {
            margin-bottom: 60px;
			@media(max-width: 1024px) {
				margin-bottom: 40px;
				img{
					height: 70px;
				}
			}
        }

        .footer_menu {
            ul {
                padding-bottom: 30px;
                border-bottom: 1px solid #FAF8F0;
                margin-bottom: 30px;
                gap: 15px;

                @media (min-width: 767px) {
                    flex-flow: wrap;
                    align-items: center;
                    justify-content: center;
                }

                li {
                    text-align: center;

                    a {
                        font-weight: 400;
                        font-size: 1.125rem;
                        line-height: 120%;
                        letter-spacing: 0;

                        &:hover {
                            color: #152637;
                        }
                    }
                }
            }
        }

        .footer_address {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 30px;
            margin-bottom: 80px;

            .address_information {
                font-weight: 500;
                font-size: 1.125rem;
                line-height: 100%;
                letter-spacing: 0;
                color: white;

                .single-address-item {
                    position: relative;
                    margin-right: 70px;

                    &:last-child {
                        margin-right: 0;

                        &:after {
                            display: none;
                        }
                    }

                    &:after {
                        position: absolute;
                        top: 7px;
                        right: -35px;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        content: "";
                        background: #FAF8F0;
                    }
                }
            }


            a {
                font-weight: 500;
                font-size: 1.125rem;
                line-height: 120%;
                letter-spacing: 0;
				@media(max-width: 767px){
					font-weight: 400;
				}

            }
			
			@media(max-width: 1024px){
				margin-bottom: 40px;
			}
        }

		
		@media(max-width: 1024px) {
			padding-top: 60px;
		}
    }


    .last-container {
        .last-container_column {
            position: relative;
            padding-top: 30px;

            &:after {
                content: "";
                width: calc(100% - 30px);
                height: 1px;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                margin: 0 auto;
                background: rgba(255, 255, 255, 1);
            }

        }

        .col-md-6 {
            &:last-child {
                @media (min-width: 767px) {
                    display: flex;
                    justify-content: flex-end;

                }
            }
        }

        p {
            font-weight: 500;
            font-size: 0.875rem;
            line-height: 1.25rem;
            letter-spacing: 0;
            color: white;
        }

        a {
            font-weight: 500;
            font-size: 0.875rem;
            line-height: 1.25rem;
            letter-spacing: 0;
            color: white;
        }
    }


    @media (max-width: 1024px) {
        .col-md-8.offset-md-2 {
            margin-left: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            flex: 0 0 100% !important;
            display: flex;
            justify-content: space-between;
        }
    }
    @media (max-width: 767px) {

        .address-wrapper, .single-address-item {
            display: flex;
            margin-right: 0 !important;

            svg {
                margin-right: 15px;
            }
        }

        .single-address-item {
            gap: 0;

            svg {
                margin-right: 15px;
            }
        }

        .align-items-center {
            align-items: center !important;
            justify-content: flex-start !important;
        }

        .footer_address {
            justify-content: flex-start !important;
            gap: 20px !important;
            align-items: flex-start !important;
        }

        .address_information {
            align-items: flex-start !important;
            justify-content: flex-start !important;
            flex-direction: column !important;

            .phone-number-list {
                &:after {
                    display: none;
                }

                margin: 0 0 20px;
            }
        }

        .last-container_column {
            gap: 20px;
        }

        .footer-wrapper {

            .footer_menu {
				padding-bottom: 35px;
				position: relative;
				margin-bottom: 30px;
				&:after{
					content: "";
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					height: 1px;
					width: calc(100% - 30px);
					background-color: white;
					margin: 0 auto;
				}
                .social {
					margin-bottom: 0 !important;
                    height: 100%;
                    justify-content: space-between;
					padding-right: 10px;
                }

                ul {
                    margin-bottom: 0;
                    padding-bottom: 0;
                    border-bottom: none;
                    flex-direction: column;

                    li {
                        text-align: left;
                    }
                }
            }

            .last-container {
                ul {
                    flex-direction: column;
                    gap: 20px;

                    li {
                        margin: 0;

                        a {
                            margin: 0;
                        }
                    }
                }
            }
        }


    }

`;

export default React.memo(Footer);
